export const MULTI_BENEFICIARY_CREATE_REQUEST = 'MULTI_BENEFICIARY_CREATE_REQUEST';
